<div class="content">
  <div class="close" (click)="close()">
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../../assets/images/close.svg"
    />
  </div>
  <div class="title">确认结单</div>
  <div mat-dialog-content class="detail" [formGroup]="formGroup">
    <div class="tip1">
      确认结单后，该工单将被归档，您将无法在此工单中继续回复或提交新反馈。
    </div>
    <app-start-review-panel
      label="产品体验"
      [list]="product_list"
      (rateChange)="onRateChangeProduct($event)"
    ></app-start-review-panel>
    <app-start-review-panel
      label="客服服务"
      [list]="service_list"
      (rateChange)="onRateChangeService($event)"
    ></app-start-review-panel>
    <app-start-review-total-panel
      [start1]="formGroup.value.service_star_level"
      [start2]="formGroup.value.product_star_level"
    ></app-start-review-total-panel>
    <div class="item">
      <div class="label">问题是否解决：</div>
      <div class="value">
        <div class="checkboxes">
          <label
            class="checkbox-item"
            [class.active]="formGroup.value.is_resolved === true"
          >
            <input
              type="radio"
              name="resolved"
              [checked]="formGroup.value.is_resolved === true"
              (change)="select(true)"
            />
            已解决
          </label>

          <label
            class="checkbox-item"
            [class.active]="formGroup.value.is_resolved === false"
          >
            <input
              type="radio"
              name="resolved"
              [checked]="formGroup.value.is_resolved === false"
              (change)="select(false)"
            />
            未解决
          </label>
        </div>
      </div>
    </div>
    <div class="item item_special">
      <div class="label">我要反馈：</div>
      <div class="value">
        <textarea
          placeholder="您的评价会让客服做的更好"
          formControlName="feedback"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="tip2">
    *
    注：若您的问题已解决，可以直接点击“确定”结单。工单在处理完成后<span>24小时</span>内若无新回复，系统亦会自动关闭。
  </div>
  <div class="btns">
    <button class="btn1" (click)="close()" [disabled]="loading">取消</button>
    <button class="btn2" (click)="onOk()" [disabled]="loading">确定</button>
  </div>
</div>
